export const inputStyle = 'p-4 w-full rounded-2xl border bg-primary-lightest';
export const buttonStyle = 'bg-primary px-6 py-3 rounded-xl text-white';
export const linkStyle = 'border-2 w-3/4 mx-auto text-center p-4 my-8';
export const errorStyle = 'text-red-300';
